// extracted by mini-css-extract-plugin
export default {"iconoMovimiento":"Iconos_iconoMovimiento__bZR5j","iconoTitulo":"Iconos_iconoTitulo__eeBWS"};